import { makeStyles } from '@material-ui/core/styles';

const COLOR_WHITE = 'white';

export const useStyles = makeStyles((theme) => ({
    main: {
        borderTop: `2px solid ${theme.palette.primary.dark}`,
        borderBottom: `2px solid ${theme.palette.primary.dark}`,
        backgroundColor: COLOR_WHITE,
        width: '100%',
        display: 'flex',
        '& p': {
            marginLeft: 0,
        },
    },
    iconWrapper: {
        padding: '25px 25px 25px 28px',
        boxSizing: 'border-box',
        maxWidth: 120,
        [theme.breakpoints.between(0, 490)]: {
            padding: '25px 10px 25px 10px',
            '& flos-icon': {
                width: '40px!important',
            },
        },
    },
    sectionLeft: {
        width: 'calc(60%)',
        lineHeight: '19px',
        padding: '12px 27px 12px 0',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& span': {
            display: 'block',
        },
        ' & h4': {
            fontSize: theme.typography.pxToRem(20),
        },
        [theme.breakpoints.between(0, 490)]: {
            width: 'calc(55%)',
            padding: '12px 10px 12px 0',
        },
    },
    sectionRight: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        marginRight: theme.typography.pxToRem(10),
        lineHeight: '16px',
        width: 'calc(40%)',
        textAlign: 'center',
        flexDirection: 'column',
        [theme.breakpoints.between(0, 490)]: {
            width: 'calc(45%)',
        },
    },
    priceWrapper: {
        textAlign: 'right',
    },
    boldHeader: {
        lineHeight: '19px',
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(30),
        color: `${theme.palette.primary.dark}`,
    },
    small: {
        color: theme.palette.primary.dark,
        fontSize: '1rem',
        marginLeft: '5px',
    },
}));
